import { render, staticRenderFns } from "./TarifsIJH.vue?vue&type=template&id=4e328767&scoped=true&"
import script from "./TarifsIJH.vue?vue&type=script&lang=js&"
export * from "./TarifsIJH.vue?vue&type=script&lang=js&"
import style0 from "./TarifsIJH.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TarifsIJH.vue?vue&type=style&index=1&id=4e328767&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e328767",
  null
  
)

export default component.exports